import * as React from 'react';

import {getIcon} from './Plugins';
import {RuntimeContext} from './RuntimeContext';

import {type QualifiedPluginIcon, type IconProps} from './PluginIconTypes';

export const PluginIcon = ({
  icon,
  ...props
}: {
  icon: QualifiedPluginIcon;
} & IconProps) => (
  <RuntimeContext.Consumer>
    {(plugins) => {
      const Icon = getIcon(plugins, icon);
      return <Icon {...props} />;
    }}
  </RuntimeContext.Consumer>
);
